import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Leaderboard")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h2 = _resolveComponent("n-h2")!
  const _component_racing_leaderboard = _resolveComponent("racing-leaderboard")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_breeding_leaderboard = _resolveComponent("breeding-leaderboard")!
  const _component_n_tabs = _resolveComponent("n-tabs")!
  const _component_n_divider = _resolveComponent("n-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_h2, {
      class: "thick-text",
      style: {"text-align":"center","text-transform":"uppercase","font-family":"'syncopate'","margin-top":"1.5rem"}
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_n_tabs, null, {
      default: _withCtx(() => [
        _createVNode(_component_n_tab_pane, {
          tab: "RACING",
          name: "racing",
          "tab-props": { style: { marginLeft: '1.5rem' } }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_racing_leaderboard)
          ]),
          _: 1
        }, 8, ["tab-props"]),
        _createVNode(_component_n_tab_pane, {
          tab: "BREEDING",
          name: "breeding"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_breeding_leaderboard)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_n_divider)
  ]))
}